export const iconFontAwesomeEnergyAtom = (
	<i className="fa-solid fa-atom"></i>
);
